interface MapPointParams {

}
/**
 * 将测点模型转为api请求的格式
 */
export function mapFetchPointParams(pointModel: Model.PointModel): any {
    const clonePointModel = _.cloneDeep(pointModel);
    return {
        pointType: clonePointModel.pointType,
        valueType: clonePointModel.valueType,
        dateRange: clonePointModel.dateRange,
        timeRange: clonePointModel.timeRange,
        pointGroup: clonePointModel.pointGroup.map( (point) => {
            return {
                pointId: point.pointId,
                aggregate: point.aggregate,
                period: point.period,
                periodAggregate: point.periodAggregate,
                childValueTyle: point.childValueTyle,
            }
        }),
        pointFormat: clonePointModel.pointFormat,
    };
}